import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { GLOBAL_FIELDS_TOUR_DISMISSED } from './cardCoversSpotlight.constants.tsx';
import type { Props, State } from './GlobalFieldsTourSteps.types.tsx';
import { maybeWaitForPremiumModal } from './maybeWaitForPremiumModal.tsx';

export const loadGlobalFieldsTourDismissed =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		await maybeWaitForPremiumModal(getState);

		// User property is already loaded
		if (typeof getState().globalFields.tourDismissed === 'boolean') {
			return;
		}

		try {
			const tourDismissed = await getUserProperty<boolean>(accountId, GLOBAL_FIELDS_TOUR_DISMISSED);

			const state = getState();

			setState({
				...state,
				globalFields: {
					...state.globalFields,
					tourDismissed,
				},
			});
		} catch (error) {
			// Expected error, the property is not set yet
			if (error instanceof FetchError && error.statusCode === 404) {
				const state = getState();

				setState({
					...state,
					globalFields: {
						...state.globalFields,
						tourDismissed: false,
					},
				});

				return;
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.global-fields.tour',
				`Failed to get user property with key: ${GLOBAL_FIELDS_TOUR_DISMISSED}`,
				error instanceof Error ? error : undefined,
			);
		}
	};

export const setGlobalFieldsTourDismissed =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		const state = getState();

		setState({
			...state,
			globalFields: {
				...state.globalFields,
				tourDismissed: true,
			},
		});

		try {
			await setUserProperties(accountId, GLOBAL_FIELDS_TOUR_DISMISSED, 'true');
		} catch (error) {
			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.global-fields.tour',
				`Failed to set user property with key: ${GLOBAL_FIELDS_TOUR_DISMISSED}`,
				error instanceof Error ? error : undefined,
			);
		}
	};
